import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper } from '../../components';

const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <div className="row">
        <div className="Node Forbidden col-12 col-lg-8 offset-lg-2">
          <h1>{t('pages.403.title')}</h1>
          <p>{t('pages.403.body')}</p>
          <ButtonWrapper primary href={t('pages.403.primary_button.url')}>{t('pages.403.primary_button.link')}</ButtonWrapper>
        </div>
      </div>
    </Container>
  );
};

export default Forbidden;
